// @flow
import React from 'react';
import Icon from '../shared/Icon';

type Props = {
  checked: boolean,
  onChange: () => void
}

const PasswordToggle = ({ checked, onChange }: Props) => {
  return (
    <div className='auth-form__show-password'>
      <button type='button' onClick={onChange} className='auth-form__toggle-password'>
        {checked &&
          <Icon name='eye-closed' size='medium' />
        }
        {!checked &&
          <Icon name='eye-open' size='medium' />
        }
      </button>
    </div>
  );
};

export default PasswordToggle;


// WEBPACK FOOTER //
// ./src/components/shared/PasswordToggle.js